/**
 * Shared Runtime Configuration
 *
 * Contains only runtime-injectable, non-UI, non-asset config values.
 * All values are resolved from window.__CONFIG__ (server-injected at runtime)
 * with build-time env-var overrides as fallback.
 *
 * Does NOT contain:
 *   - sidebar / navigation structure  → src_unified/templates/<skin>/navigation.js
 *   - static asset references         → src_unified/templates/<skin>/assets.js
 *   - statistics group params          → src_unified/core/config.js
 *   - locale selector data with flags  → src_unified/templates/<skin>/assets.js
 */

// Merge configs from public/config.js and public/envs.js (injected into window.__CONFIG__ by the server)
const WIN_CFG = (typeof window !== 'undefined' && window.__CONFIG__) ? window.__CONFIG__ : {};

export default {
    ...window.__CONFIG__,
    ...WIN_CFG,
    cpaUrl: process.env.REACT_APP_CPA_URL || WIN_CFG.cpaUrl,
    landingUrl: process.env.REACT_APP_LANDINGS_URL || WIN_CFG.landingUrl,
    shortUrl: process.env.REACT_APP_SHORTENER_URL || WIN_CFG.shortUrl,
    adminUrl: process.env.REACT_APP_ADMIN_URL || WIN_CFG.adminUrl,
    tdsUrl: process.env.REACT_APP_TDS_URL || WIN_CFG.tdsUrl,
    clientId: process.env.REACT_APP_CLIENT_ID || WIN_CFG.clientId,
    sideBarUrl: process.env.REACT_APP_SIDEBAR_URL || WIN_CFG.sideBarUrl,
    advertiserUrl: process.env.REACT_APP_ADVERTISER_URL || WIN_CFG.advertiserUrl,
    dnsMap: process.env.REACT_APP_DNS_MAP ? JSON.parse(process.env.REACT_APP_DNS_MAP) : WIN_CFG.dnsMap,
    allowGeneratePromocodes: process.env.ALLOW_GENERATE_PROMOCODES === 'true' || WIN_CFG.allowGeneratePromocodes === 'true',
    defaultRoute: WIN_CFG.defaultRoute || '/',
    codeFormat: WIN_CFG.codeFormat || 'YYYY-MM-DD',
    reportHourFormat: WIN_CFG.reportHourFormat || 'YYYY-MM-DD HH:mm:ss',
    defaultShowChart: WIN_CFG.defaultShowChart || 'show',
    defaultBindActions: WIN_CFG.defaultBindActions || 'time',
    defaultGroupBy: WIN_CFG.defaultGroupBy || 'Day',
    defaultCount: Number.isFinite(WIN_CFG.defaultCount) ? WIN_CFG.defaultCount : 20,
    listCounts: Array.isArray(WIN_CFG.listCounts) && WIN_CFG.listCounts.length ? WIN_CFG.listCounts : [10, 20, 50, 100],
    itemsCountPerPage: Number.isFinite(WIN_CFG.itemsCountPerPage) ? WIN_CFG.itemsCountPerPage : 20,
    initialPage: Number.isFinite(WIN_CFG.initialPage) ? WIN_CFG.initialPage : 1,
    defaultDatepickerDaysPeriod: Number.isFinite(WIN_CFG.defaultDatepickerDaysPeriod) ? WIN_CFG.defaultDatepickerDaysPeriod : 7,
    defaultDatepickerMonthPayoutPeriod: Number.isFinite(WIN_CFG.defaultDatepickerMonthPayoutPeriod) ? WIN_CFG.defaultDatepickerMonthPayoutPeriod : 1,
};
